import React from 'react';
import PropTypes from 'prop-types';
import './StatCard.css';

function StatCard({ icon, value, label, trend, color }) {
  return (
    <div className={`stat-card ${color ? `stat-card--${color}` : ''}`}>
      {icon && <span className="stat-card-icon">{icon}</span>}
      <span className="stat-card-value">{value != null ? value.toLocaleString?.() ?? value : '—'}</span>
      <span className="stat-card-label">{label}</span>
      {trend && (
        <span className={`stat-card-trend stat-card-trend--${trend.direction || 'neutral'}`}>
          {trend.direction === 'up' ? '▲' : trend.direction === 'down' ? '▼' : '●'} {trend.label}
        </span>
      )}
    </div>
  );
}

StatCard.propTypes = {
  icon:  PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string.isRequired,
  trend: PropTypes.shape({ direction: PropTypes.oneOf(['up', 'down', 'neutral']), label: PropTypes.string }),
  color: PropTypes.string,
};

export default StatCard;
